// Единый реестр AI-инструментов — единственный источник правды для:
//  • генерации отдельных SEO-страниц (gatsby-node.js → src/templates/tool-page.js);
//  • рендера инструмента по id (src/components/ai/ToolRenderer.js);
//  • пунктов бокового меню и ссылок (src/components/SidebarMenu.js).
//
// CommonJS (module.exports), чтобы файл читался и из gatsby-node.js (CJS),
// и из React-компонентов (import { TOOLS } ... — Babel даёт interop).
//
// Каждая запись описывает публичный инструмент. Скрытая админ-панель (id: 'admin')
// сюда НЕ входит и отдельной страницы не получает.

const TOOLS = [
  {
    id: 'auto-product-card',
    slug: 'bot-fotosessij',
    section: 'photo',
    name: 'Бот фотосессий',
    seo: {
      title: 'Бот фотосессий — автоматическая карточка товара нейросетью | airun.art',
      description:
        'ИИ-бот создаёт готовую карточку товара из одного фото: анализирует продукт и генерирует фон и сцену для Wildberries и Ozon за секунды.',
      keywords: [
        'карточка товара нейросеть',
        'авто карточка товара',
        'фото для Wildberries',
        'фото для Ozon',
        'бот фотосессий',
        'предметная съёмка ИИ',
        'карточка для маркетплейса',
      ],
      h1: 'Бот фотосессий: автоматическая карточка товара нейросетью',
      intro:
        'Загрузите фото товара — ИИ сам подберёт фон, свет и композицию и соберёт готовую карточку для маркетплейса. Без студии, фотографа и ручного редактирования.',
    },
  },
  {
    id: 'replace-model',
    slug: 'fotoredaktor',
    section: 'photo',
    name: 'Фоторедактор',
    seo: {
      title: 'Фоторедактор ИИ — редактирование фото по описанию | airun.art',
      description:
        'Редактируйте фотографии текстом: меняйте фон, одежду, детали и модель на снимке. ИИ-фоторедактор на базе nano banana и GPT.',
      keywords: [
        'фоторедактор ИИ',
        'редактирование фото по описанию',
        'замена модели',
        'изменить фото нейросетью',
        'редактор фото онлайн',
        'nano banana',
      ],
      h1: 'Фоторедактор ИИ — меняйте фото по текстовому описанию',
      intro:
        'Опишите словами, что изменить на снимке — фон, одежду, позу или детали — и нейросеть аккуратно перерисует фото, сохранив естественный свет и тени.',
    },
  },
  {
    id: 'retouch',
    slug: 'retush',
    section: 'photo',
    name: 'Ретушь',
    seo: {
      title: 'Ретушь фото онлайн — удалить объект, заменить часть фото | airun.art',
      description:
        'AI инпейнтинг онлайн: выделите участок кистью — нейросеть удалит лишнее с фото, заменит часть фото, дорисует предмет или заменит текст на фото.',
      keywords: [
        'ретушь фото онлайн',
        'удалить объект с фото',
        'убрать лишнее с фото',
        'заменить часть фото',
        'дорисовать фото нейросетью',
        'заменить текст на фото',
        'инпейнтинг',
        'нейросеть ретушь',
      ],
      h1: 'Ретушь фото онлайн — AI инпейнтинг по выделению',
      intro:
        'Выделите участок фото кистью или пером и напишите, что сделать: удалить объект, заменить его, добавить предмет или переписать текст. Нейросеть изменит только выделенное, остальной кадр останется как был.',
    },
  },
  {
    id: 'replace-background',
    slug: 'zamena-fona',
    section: 'photo',
    name: 'Ты фотограф',
    seo: {
      title: 'Замена фона на фото онлайн нейросетью — «Ты фотограф» | airun.art',
      description:
        'Меняйте фон на фотографии одним описанием: перенесите модель в любую локацию с реалистичным светом и тенями. Замена фона ИИ онлайн.',
      keywords: [
        'замена фона',
        'смена фона онлайн',
        'заменить фон на фото',
        'фотограф ИИ',
        'изменить фон нейросетью',
        'фон для фото',
      ],
      h1: 'Замена фона на фото онлайн — нейросеть «Ты фотограф»',
      intro:
        'Перенесите героя снимка в любую сцену: опишите локацию, и ИИ заменит фон с естественным освещением и тенями, как на настоящей фотосессии.',
    },
  },
  {
    id: 'photosession',
    slug: 'fotosessiya',
    section: 'photo',
    name: 'Фотосессия',
    seo: {
      title: 'ИИ фотосессия онлайн — фото модели без студии | airun.art',
      description:
        'Виртуальная фотосессия с готовыми локациями и позами: получите профессиональные кадры модели за секунды, без студии и фотографа.',
      keywords: [
        'ИИ фотосессия',
        'виртуальная фотосессия',
        'фотосессия нейросеть',
        'фото без студии',
        'фотосессия онлайн',
        'модель ИИ',
      ],
      h1: 'ИИ фотосессия онлайн — профессиональные кадры без студии',
      intro:
        'Выберите локацию и позы — нейросеть создаст профессиональную фотосессию с естественным освещением. Готовые кадры за секунды, без аренды студии.',
    },
  },
  {
    id: 'photo-generation',
    slug: 'generaciya-foto',
    section: 'photo',
    name: 'Генерация фото',
    seo: {
      title: 'Генерация фото нейросетью по тексту — ИИ картинки | airun.art',
      description:
        'Создавайте изображения из текстового описания: ИИ-генерация фото на базе nano banana 2, nano banana pro и GPT в разрешении до 4K.',
      keywords: [
        'генерация фото',
        'нейросеть генерация изображений',
        'ИИ фото по тексту',
        'создать картинку нейросетью',
        'nano banana 2',
        'nano banana pro',
        'генерация изображений онлайн',
      ],
      h1: 'Генерация фото нейросетью по текстовому описанию',
      intro:
        'Опишите желаемое изображение — нейросеть сгенерирует фото в высоком разрешении. Поддержка моделей nano banana 2, nano banana pro и GPT.',
    },
  },
  {
    id: 'vector-ai',
    slug: 'vektornaya-grafika',
    section: 'photo',
    name: 'Векторная AI',
    seo: {
      title: 'Векторная AI — генерация логотипов и иконок в SVG нейросетью | airun.art',
      description:
        'Создайте логотип, иконку, ярлычок или элемент инфографики в формате SVG за секунды: нейросети Recraft и Quiver генерируют чистую векторную графику по текстовому описанию.',
      keywords: [
        'векторная графика нейросеть',
        'генерация логотипа ИИ',
        'создать логотип нейросетью',
        'SVG генератор онлайн',
        'иконки нейросеть',
        'ярлыки и этикетки ИИ',
        'элементы инфографики',
        'Recraft',
        'Quiver',
      ],
      h1: 'Векторная AI — логотипы и иконки в SVG по описанию',
      intro:
        'Опишите словами логотип, иконку, ярлычок или элемент инфографики — нейросети Recraft и Quiver создадут готовый вектор в формате SVG. Он масштабируется без потери качества и сразу подходит для печати, сайта и маркетплейса.',
    },
  },
  {
    id: 'photo-to-video',
    slug: 'foto-v-video',
    section: 'video',
    name: 'Фото в Видео',
    seo: {
      title: 'Оживить фото — из фото в видео нейросетью | airun.art',
      description:
        'Превратите фотографию в короткое видео: ИИ анимирует снимок по вашему описанию движения. Оживление фото на базе seedance.',
      keywords: [
        'оживить фото',
        'фото в видео',
        'анимация фото',
        'из фото видео нейросеть',
        'seedance',
        'ИИ видео из фото',
        'оживление фотографий',
      ],
      h1: 'Оживить фото — превратите снимок в видео нейросетью',
      intro:
        'Загрузите фото и опишите движение — ИИ создаст живое видео из статичного кадра. Готовый кинопромпт можно сгенерировать автоматически.',
    },
  },
  {
    id: 'video-merge',
    slug: 'video-montazh',
    section: 'video',
    name: 'Видео монтаж',
    seo: {
      title: 'Склейка и монтаж видео онлайн — обрезка видео | airun.art',
      description:
        'Объединяйте и обрезайте видео онлайн бесплатно: соберите несколько роликов в один клип прямо в браузере, без установки программ.',
      keywords: [
        'склейка видео',
        'видеомонтаж онлайн',
        'объединить видео',
        'обрезка видео',
        'монтаж видео бесплатно',
        'склеить видео онлайн',
      ],
      h1: 'Склейка и монтаж видео онлайн',
      intro:
        'Загрузите несколько роликов, чтобы объединить их в один клип, или обрежьте одно видео — быстро и бесплатно, прямо в браузере.',
    },
  },
];

const getToolById = (id) => TOOLS.find((t) => t.id === id) || null;
const getToolBySlug = (slug) => TOOLS.find((t) => t.slug === slug) || null;
const getToolPath = (idOrTool) => {
  const tool = typeof idOrTool === 'string' ? getToolById(idOrTool) : idOrTool;
  return tool ? `/ai-photo/${tool.slug}/` : '/ai-photo/';
};

module.exports = { TOOLS, getToolById, getToolBySlug, getToolPath };
